// import React, { useState, useEffect } from 'react';
// import {
//   FaAngleLeft,
//   FaAngleRight,
//   FaAngleDoubleLeft,
//   FaAngleDoubleRight,
// } from 'react-icons/fa';

// const Pagination = ({
//   currentPage,
//   totalPages,
//   onPageChange,
//   itemsPerPage,
//   totalItems,
// }) => {
//   const [inputPage, setInputPage] = useState(currentPage.toString());

//   useEffect(() => {
//     setInputPage(currentPage.toString());
//   }, [currentPage]);

//   const handleInputChange = (e) => {
//     setInputPage(e.target.value);
//   };

//   const handleInputSubmit = (e) => {
//     e.preventDefault();
//     const page = parseInt(inputPage);
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pageNumbers = [];
//     const showEllipsis = totalPages > 7;

//     if (showEllipsis) {
//       if (currentPage <= 4) {
//         for (let i = 1; i <= 5; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 w-8 h-8 rounded-full ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//         pageNumbers.push(<span key='ellipsis1'>...</span>);
//         pageNumbers.push(
//           <button
//             key={totalPages}
//             onClick={() => onPageChange(totalPages)}
//             className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage >= totalPages - 3) {
//         pageNumbers.push(
//           <button
//             key={1}
//             onClick={() => onPageChange(1)}
//             className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
//           >
//             1
//           </button>
//         );
//         pageNumbers.push(<span key='ellipsis2'>...</span>);
//         for (let i = totalPages - 4; i <= totalPages; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 w-8 h-8 rounded-full ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//       } else {
//         pageNumbers.push(
//           <button
//             key={1}
//             onClick={() => onPageChange(1)}
//             className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
//           >
//             1
//           </button>
//         );
//         pageNumbers.push(<span key='ellipsis3'>...</span>);
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 w-8 h-8 rounded-full ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//         pageNumbers.push(<span key='ellipsis4'>...</span>);
//         pageNumbers.push(
//           <button
//             key={totalPages}
//             onClick={() => onPageChange(totalPages)}
//             className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
//           >
//             {totalPages}
//           </button>
//         );
//       }
//     } else {
//       for (let i = 1; i <= totalPages; i++) {
//         pageNumbers.push(
//           <button
//             key={i}
//             onClick={() => onPageChange(i)}
//             className={`mx-1 w-8 h-8 rounded-full ${
//               currentPage === i
//                 ? 'bg-blue-500 text-white'
//                 : 'bg-gray-200 hover:bg-gray-300'
//             }`}
//           >
//             {i}
//           </button>
//         );
//       }
//     }

//     return pageNumbers;
//   };

//   return (
//     <div className='flex flex-col items-center space-y-2 mt-4'>
//       <div className='flex items-center space-x-2'>
//         <button
//           onClick={() => onPageChange(1)}
//           disabled={currentPage === 1}
//           className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleDoubleLeft />
//         </button>
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleLeft />
//         </button>
//         {/* <div className='hidden sm:flex items-center space-x-1'> */}
//         <div className='sm:flex items-center space-x-1'>
//           {renderPageNumbers()}
//         </div>
//         <span className='mx-2 sm:hidden'>
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleRight />
//         </button>
//         <button
//           onClick={() => onPageChange(totalPages)}
//           disabled={currentPage === totalPages}
//           className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleDoubleRight />
//         </button>
//       </div>

//       <form
//         onSubmit={handleInputSubmit}
//         className='flex items-center space-x-2'
//       >
//         <input
//           type='number'
//           min='1'
//           max={totalPages}
//           value={inputPage}
//           onChange={handleInputChange}
//           className='w-16 px-2 py-1 border rounded'
//         />
//         <button
//           type='submit'
//           className='px-3 py-1 rounded bg-blue-500 text-white hover:bg-blue-600'
//         >
//           Go
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Pagination;

// import React from 'react';
import React, { useState, useEffect } from 'react';

import {
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from 'react-icons/fa';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  totalItems,
}) => {
  const [inputPage, setInputPage] = useState(currentPage.toString());

  useEffect(() => {
    setInputPage(currentPage.toString());
  }, [currentPage]);

  const handleInputChange = (e) => {
    setInputPage(e.target.value);
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    const page = parseInt(inputPage);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const showEllipsis = totalPages > 5;

    if (showEllipsis) {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pageNumbers.push(
            <button
              key={i}
              onClick={() => onPageChange(i)}
              className={`mx-1 w-8 h-8 rounded-full ${
                currentPage === i
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              {i}
            </button>
          );
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pageNumbers.push(
            <button
              key={i}
              onClick={() => onPageChange(i)}
              className={`mx-1 w-8 h-8 rounded-full ${
                currentPage === i
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              {i}
            </button>
          );
        }
      } else {
        pageNumbers.push(
          <button
            key={currentPage - 1}
            onClick={() => onPageChange(currentPage - 1)}
            className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
          >
            {currentPage - 1}
          </button>
        );
        pageNumbers.push(
          <button
            key={currentPage}
            onClick={() => onPageChange(currentPage)}
            className='mx-1 w-8 h-8 rounded-full bg-blue-500 text-white'
          >
            {currentPage}
          </button>
        );
        pageNumbers.push(
          <button
            key={currentPage + 1}
            onClick={() => onPageChange(currentPage + 1)}
            className='mx-1 w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300'
          >
            {currentPage + 1}
          </button>
        );
      }
    } else {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`mx-1 w-8 h-8 rounded-full ${
              currentPage === i
                ? 'bg-blue-500 text-white'
                : 'bg-gray-200 hover:bg-gray-300'
            }`}
          >
            {i}
          </button>
        );
      }
    }

    return pageNumbers;
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className='flex flex-col items-center space-y-2 mt-4'>
      {/* Small Screens */}
      <div className='flex items-center space-x-2 sm:hidden'>
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleDoubleLeft />
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleLeft />
        </button>
        <span className='w-8 h-8 flex items-center justify-center rounded-full bg-blue-500 text-white'>
          {currentPage}
        </span>
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleRight />
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleDoubleRight />
        </button>
      </div>

      {/* Large Screens */}
      <div className='hidden sm:flex items-center space-x-2'>
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleDoubleLeft />
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleLeft />
        </button>
        {renderPageNumbers()}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleRight />
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className='p-2 rounded-full bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
        >
          <FaAngleDoubleRight />
        </button>
      </div>

      {/* <div className='text-sm text-gray-500'>
        {startItem}-{endItem} of {totalItems} items
      </div> */}
      <div className='text-sm text-gray-500'>
        Page {currentPage} of {totalPages}
      </div>

      <form
        onSubmit={handleInputSubmit}
        className='flex items-center space-x-2'
      >
        <input
          type='number'
          min='1'
          max={totalPages}
          value={inputPage}
          onChange={handleInputChange}
          className='w-16 px-2 py-1 border rounded'
        />
        <button
          type='submit'
          className='px-3 py-1 rounded bg-blue-500 text-white hover:bg-blue-600'
        >
          Go
        </button>
      </form>
    </div>
  );
};

export default Pagination;

// import React, { useState } from 'react';
// import {
//   FaAngleLeft,
//   FaAngleRight,
//   FaAngleDoubleLeft,
//   FaAngleDoubleRight,
// } from 'react-icons/fa';

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//   const [inputPage, setInputPage] = useState(currentPage);

//   const handleInputChange = (e) => {
//     setInputPage(e.target.value);
//   };

//   const handleInputSubmit = (e) => {
//     e.preventDefault();
//     const page = parseInt(inputPage);
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pageNumbers = [];
//     const showEllipsis = totalPages > 7;

//     if (showEllipsis) {
//       if (currentPage <= 4) {
//         for (let i = 1; i <= 5; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 px-3 py-1 rounded ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//         pageNumbers.push(<span key='ellipsis1'>...</span>);
//         pageNumbers.push(
//           <button
//             key={totalPages}
//             onClick={() => onPageChange(totalPages)}
//             className='mx-1 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300'
//           >
//             {totalPages}
//           </button>
//         );
//       } else if (currentPage >= totalPages - 3) {
//         pageNumbers.push(
//           <button
//             key={1}
//             onClick={() => onPageChange(1)}
//             className='mx-1 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300'
//           >
//             1
//           </button>
//         );
//         pageNumbers.push(<span key='ellipsis2'>...</span>);
//         for (let i = totalPages - 4; i <= totalPages; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 px-3 py-1 rounded ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//       } else {
//         pageNumbers.push(
//           <button
//             key={1}
//             onClick={() => onPageChange(1)}
//             className='mx-1 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300'
//           >
//             1
//           </button>
//         );
//         pageNumbers.push(<span key='ellipsis3'>...</span>);
//         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//           pageNumbers.push(
//             <button
//               key={i}
//               onClick={() => onPageChange(i)}
//               className={`mx-1 px-3 py-1 rounded ${
//                 currentPage === i
//                   ? 'bg-blue-500 text-white'
//                   : 'bg-gray-200 hover:bg-gray-300'
//               }`}
//             >
//               {i}
//             </button>
//           );
//         }
//         pageNumbers.push(<span key='ellipsis4'>...</span>);
//         pageNumbers.push(
//           <button
//             key={totalPages}
//             onClick={() => onPageChange(totalPages)}
//             className='mx-1 px-3 py-1 rounded bg-gray-200 hover:bg-gray-300'
//           >
//             {totalPages}
//           </button>
//         );
//       }
//     } else {
//       for (let i = 1; i <= totalPages; i++) {
//         pageNumbers.push(
//           <button
//             key={i}
//             onClick={() => onPageChange(i)}
//             className={`mx-1 px-3 py-1 rounded ${
//               currentPage === i
//                 ? 'bg-blue-500 text-white'
//                 : 'bg-gray-200 hover:bg-gray-300'
//             }`}
//           >
//             {i}
//           </button>
//         );
//       }
//     }

//     return pageNumbers;
//   };

//   return (
//     <div className='flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-2 mt-4'>
//       <div className='flex items-center space-x-2'>
//         <button
//           onClick={() => onPageChange(1)}
//           disabled={currentPage === 1}
//           className='px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleDoubleLeft />
//         </button>
//         <button
//           onClick={() => onPageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className='px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleLeft />
//         </button>
//       </div>
//       <div className='hidden sm:flex items-center space-x-1'>
//         {renderPageNumbers()}
//       </div>
//       <div className='flex items-center space-x-2'>
//         <button
//           onClick={() => onPageChange(currentPage + 1)}
//           disabled={currentPage === totalPages}
//           className='px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleRight />
//         </button>
//         <button
//           onClick={() => onPageChange(totalPages)}
//           disabled={currentPage === totalPages}
//           className='px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50'
//         >
//           <FaAngleDoubleRight />
//         </button>
//       </div>
//       <form
//         onSubmit={handleInputSubmit}
//         className='flex items-center space-x-2'
//       >
//         <input
//           type='number'
//           min='1'
//           max={totalPages}
//           value={inputPage}
//           onChange={handleInputChange}
//           className='w-16 px-2 py-1 border rounded'
//         />
//         <button
//           type='submit'
//           className='px-3 py-1 rounded bg-blue-500 text-white hover:bg-blue-600'
//         >
//           Go
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Pagination;
